import { makeStyles } from "@/ui/kit/styles/makeStyles";

export default makeStyles()((theme) => ({
  paper: {
    borderTopLeftRadius: +theme.shape.borderRadius * 4,
    borderTopRightRadius: +theme.shape.borderRadius * 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: "none",
    maxHeight: "calc(100% - 56px)",
    "&::before": {
      content: "''",
      position: "absolute",
      width: 64,
      height: 4,
      top: 8,
      left: 0,
      right: 0,
      margin: "0 auto",
      borderRadius: 8,
      backgroundColor: theme.palette.line.primary,
    },
  },
}));
